<div id="cookies-container" [hidden]="!this.authenticationService._userInfoView.SelectedClient">
  <!-- <div *ngIf="ccmVisible">
  CCM Country: <input type="text" width="50" name="ccmInput" [(ngModel)]="ccm">&nbsp;<a href="javascript:void(0)" title="Go" (click)="handleCCMClick(ccm)">Go</a>
</div> -->
@if (showBlackBar) {
  <div id="consent_blackbar">
  </div>
}
</div>
